/**
 * Self-funding sequence, step 1: which accounts and assets the consumer has. Hosts the shared
 * funding-source picker; the picked types are saved in the consumer plan (awaited, so a refresh on
 * the next step still has them) before moving on.
 */
import { FundingSourceSelection } from '@/features/funding-sources';
import { FundingScreenFrame } from '../components/funding-screen-frame';
import { useConsumerFlow } from '../hooks/use-consumer-flow';
import { useSelfFundingSequence } from '../hooks/use-self-funding-sequence';
import type { ConsumerStepProps } from './step-props';

export function AssetsStep({ clientId }: ConsumerStepProps) {
  const { goWithin, back } = useConsumerFlow(clientId);
  const sequence = useSelfFundingSequence(clientId);

  return (
    <FundingSourceSelection
      existingSelfFundingSources={sequence.fundingSources?.selfFunding}
      savedSelection={sequence.savedTypes}
      isLoading={sequence.isLoading}
      readOnly={false}
      isSaving={sequence.isPlanSaving}
      onContinue={async types => {
        await sequence.saveTypes(types);
        goWithin('assessment-intro');
      }}
      frame={parts => (
        <FundingScreenFrame
          step="assets"
          parts={{ ...parts, backAction: { label: 'Back', onSelect: () => back('self-fund') } }}
        />
      )}
    />
  );
}
